import type { CancelToken } from 'axios';

import axios from 'axios';

import { trimSlashes } from '../utils/stringUtils';

export const getCancellationToken = (abortSignal?: AbortSignal): CancelToken => {
    const source = axios.CancelToken.source();
    if (abortSignal) {
        abortSignal.addEventListener('abort', () => {
            source.cancel();
        });
    }

    return source.token;
};

export const buildMockedApiUrl = (segments: string[]) => segments.map(trimSlashes).join('/');
